<script>
import isEmpty from 'lodash/isEmpty';

export default {
  components: {},
  props: {
    footerWidth: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    hasActionBtns() {
      return !isEmpty(this.$slots);
    },
  },
  mounted() {},
  methods: {
    save() {
      this.$emit('save-action');
    },
    cancel() {
      this.$emit('canxcel-action');
    },
    delete() {
      this.$emit('delete-action');
    },
  },
};
</script>

<template>
  <div class="panel-footer" :style="`width: ${footerWidth}px;`">
    <BaseButton
      v-if="!hasActionBtns"
      type="button"
      class="btn-primary btn-clear"
      @click="confirmDelete"
    >
      <BaseIcon name="trash" />
      Delete
    </BaseButton>
    <BaseButton
      v-if="!hasActionBtns"
      type="button"
      class="btn-primary btn-clear"
      @click="clearForm"
    >
      <BaseIcon name="times" />
      Cancel Changes
    </BaseButton>
    <span v-if="!hasActionBtns" class="divider-vertical">&nbsp;</span>
    <BaseButton
      v-if="!hasActionBtns"
      type="button"
      class="btn-primary btn-clear"
      @click="save"
    >
      <BaseIcon name="save" />
      Save Changes
    </BaseButton>
    <slot name="footerLeftTitle" />
    <slot name="footerRightTitle" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.panel-footer {
  align-items: center;
  background-color: $color-header-bg;
  border-radius: $size-input-border-radius;
  bottom: 10rem;
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
  position: fixed;
  width: 94%;
  z-index: 9999;
  @media screen and (max-width: 1024px) {
    width: 90% !important;
  }

  &.form-error {
    background-color: $color-error-dark;
  }

  .divider-vertical {
    border-left: 1px solid white;
    height: 2.5rem;
    opacity: 0.4;
  }

  .btn-primary {
    &:active {
      background: rgba($color-white-wo-rgb, 0.1);
      color: white;
    }

    &:focus {
      background: transparent;
      color: white;
    }

    &:not(:disabled):not(.disabled) {
      &:active {
        background: rgba($color-white-wo-rgb, 0.1);
        color: white;
      }

      &:focus {
        background: transparent;
        color: white;
      }
    }
  }

  .btn-clear {
    color: white;
  }

  .left-title {
    color: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    justify-self: flex-start;
    letter-spacing: 0.116667px;
    line-height: 19px;
  }
}
</style>
